import { createAction } from '@reduxjs/toolkit';

// entrypoint actions
export const GET_TEMPLATES = 'GET_TEMPLATES';
export const GET_TEMPLATE = 'GET_TEMPLATE';
export const CREATE_TEMPLATE = 'CREATE_TEMPLATE';
export const UPDATE_TEMPLATE = 'UPDATE_TEMPLATE';
export const DELETE_TEMPLATES = 'DELETE_TEMPLATES';
export const SET_CURRENT_TEMPLATE = 'SET_CURRENT_TEMPLATE';
export const UNSET_CURRENT_TEMPLATE = 'UNSET_CURRENT_TEMPLATE';
export const CLEAR_TEMPLATE_ERROR = 'CLEAR_TEMPLATE_ERROR';
export const CLEAR_TEMPLATE_STORE = 'CLEAR_TEMPLATE_STORE';
export const WARN_AND_ARCHIVE_TEMPLATE = 'WARN_AND_ARCHIVE_TEMPLATE';
export const TEST_TEMPLATE = 'TEST_TEMPLATE';

export const GET_PAGINATED_TEMPLATES = 'GET_PAGINATED_TEMPLATES';
export const GET_MINIMAL_TEMPLATES = 'GET_MINIMAL_TEMPLATES';
export const GET_TEMPLATE_NAMES_BY_UUIDS = 'GET_TEMPLATE_NAMES_BY_UUIDS';
export const GET_TEMPLATE_TAGS = 'GET_TEMPLATE_TAGS';
export const GETTING_TEMPLATE_TAGS = 'GETTING_TEMPLATE_TEMPLATE_TAGS';
export const GETTING_TEMPLATE_TAGS_FAILED = 'GETTING_TEMPLATE_TAGS_FAILED';
export const GETTING_TEMPLATE_TAGS_SUCCEEDED =
  'GETTING_TEMPLATE_TAGS_SUCCEEDED';

// async actions
export const GETTING_TEMPLATES = 'GETTING_TEMPLATES';
export const GETTING_TEMPLATES_SUCCEEDED = 'GETTING_TEMPLATES_SUCCEEDED';
export const GETTING_TEMPLATES_FAILED = 'GETTING_TEMPLATES_FAILED';

export const GETTING_PAGINATED_TEMPLATES = 'GETTING_PAGINATED_TEMPLATES';
export const GETTING_PAGINATED_TEMPLATES_SUCCEEDED =
  'GETTING_PAGINATED_TEMPLATES_SUCCEEDED';
export const GETTING_PAGINATED_TEMPLATES_FAILED =
  'GETTING_PAGINATED_TEMPLATES_FAILED';

export const GETTING_MINIMAL_TEMPLATES = 'GETTING_MINIMAL_TEMPLATES';
export const GETTING_MINIMAL_TEMPLATES_SUCCEEDED =
  'GETTING_MINIMAL_TEMPLATES_SUCCEEDED';
export const GETTING_MINIMAL_TEMPLATES_FAILED =
  'GETTING_MINIMAL_TEMPLATES_FAILED';
export const GETTING_TEMPLATE_NAMES_BY_UUIDS =
  'GETTING_TEMPLATE_NAMES_BY_UUIDS';
export const GETTING_TEMPLATE_NAMES_BY_UUIDS_SUCCEEDED =
  'GETTING_TEMPLATE_NAMES_BY_UUIDS_SUCCEEDED';
export const GETTING_TEMPLATE_NAMES_BY_UUIDS_FAILED =
  'GETTING_TEMPLATE_NAMES_BY_UUIDS_FAILED';

export const GETTING_TEMPLATE = 'GETTING_TEMPLATE';
export const GETTING_TEMPLATE_FAILED = 'GETTING_TEMPLATE_FAILED';
export const GETTING_TEMPLATE_SUCCEEDED = 'GETTING_TEMPLATE_SUCCEEDED';

export const CREATING_TEMPLATE = 'CREATING_TEMPLATE';
export const CREATING_TEMPLATE_SUCCEEDED = 'CREATING_TEMPLATE_SUCCEEDED';
export const CREATING_TEMPLATE_FAILED = 'CREATING_TEMPLATE_FAILED';

export const UPDATING_TEMPLATE = 'UPDATING_TEMPLATE';
export const UPDATING_TEMPLATE_SUCCEEDED = 'UPDATING_TEMPLATE_SUCCEEDED';
export const UPDATING_TEMPLATE_FAILED = 'UPDATING_TEMPLATE_FAILED';

export const DELETING_TEMPLATES = 'DELETING_TEMPLATES';
export const DELETING_TEMPLATES_SUCCEEDED = 'DELETING_TEMPLATES_SUCCEEDED';
export const DELETING_TEMPLATES_FAILED = 'DELETING_TEMPLATES_FAILED';

export const TESTING_TEMPLATE = 'TESTING_TEMPLATE';
export const TESTING_TEMPLATE_SUCCEEDED = 'TESTING_TEMPLATE_SUCCEEDED';
export const TESTING_TEMPLATE_FAILED = 'TESTING_TEMPLATE_FAILED';

export const TEMPLATE_AUTO_SAVE_TIMER_START = 'TEMPLATE_AUTO_SAVE_TIMER_START';
export const TEMPLATE_AUTO_SAVE_TIMER_END = 'TEMPLATE_AUTO_SAVE_TIMER_END';

export const GETTING_ASSOCIATED_CAMPAIGNS_FOR_TEMPLATE =
  'GETTING_ASSOCIATED_CAMPAIGNS_FOR_TEMPLATE';
export const GETTING_ASSOCIATED_CAMPAIGNS_FOR_TEMPLATE_SUCCEEDED =
  'GETTING_ASSOCIATED_CAMPAIGNS_FOR_TEMPLATE_SUCCEEDED';
export const GETTING_ASSOCIATED_CAMPAIGNS_FOR_TEMPLATE_FAILED =
  'GETTING_ASSOCIATED_CAMPAIGNS_FOR_TEMPLATE_FAILED';

export const SET_COPY_CURRENT_TEMPLATE = 'SET_COPY_CURRENT_TEMPLATE';

export const SET_NEXT_STEP = 'SET_NEXT_STEP';
export const UNSET_NEXT_STEP = 'UNSET_NEXT_STEP';

export const UPDATE_COMMUNICATION_FILTERS = 'UPDATE_COMMUNICATION_FILTERS';
export const RESET_COMMUNICATION_FILTERS = 'RESET_COMMUNICATION_FILTERS';

export const getTemplates = createAction(GET_TEMPLATES);

export const getTemplate = createAction(GET_TEMPLATE);

export const createTemplate = createAction(CREATE_TEMPLATE);

export const updateTemplate = createAction(UPDATE_TEMPLATE);

export const deleteTemplates = createAction(DELETE_TEMPLATES);

export const warnAndArchiveTemplate = createAction(WARN_AND_ARCHIVE_TEMPLATE);

export const setCurrentTemplate = createAction(SET_CURRENT_TEMPLATE);

export const unsetCurrentTemplate = createAction(UNSET_CURRENT_TEMPLATE);

export const clearTemplateError = createAction(CLEAR_TEMPLATE_ERROR);

export const clearTemplateStore = createAction(CLEAR_TEMPLATE_STORE);

export const gettingTemplates = createAction(GETTING_TEMPLATES);

export const setNextStep = createAction(SET_NEXT_STEP);
export const unsetNextStep = createAction(UNSET_NEXT_STEP);

export const gettingTemplatesSucceeded = createAction(
  GETTING_TEMPLATES_SUCCEEDED
);

export const gettingTemplatesFailed = createAction(GETTING_TEMPLATES_FAILED);

export const gettingTemplate = createAction(GETTING_TEMPLATE);

export const gettingTemplateSucceeded = createAction(
  GETTING_TEMPLATE_SUCCEEDED
);

export const gettingPaginatedTemplatesSucceeded = createAction(
  GETTING_PAGINATED_TEMPLATES_SUCCEEDED
);

export const gettingPaginatedTemplatesFailed = createAction(
  GETTING_PAGINATED_TEMPLATES_FAILED
);

export const gettingPaginatedTemplates = createAction(
  GETTING_PAGINATED_TEMPLATES
);

export const gettingMinimalTemplates = createAction(GETTING_MINIMAL_TEMPLATES);

export const gettingMinimalTemplatesSucceeded = createAction(
  GETTING_MINIMAL_TEMPLATES_SUCCEEDED
);

export const gettingMinimalTemplatesFailed = createAction(
  GETTING_MINIMAL_TEMPLATES_FAILED
);

export const getTemplateNamesByUuids = createAction(
  GET_TEMPLATE_NAMES_BY_UUIDS
);

export const gettingTemplateNamesByUuids = createAction(
  GETTING_TEMPLATE_NAMES_BY_UUIDS
);

export const gettingTemplateNamesByUuidsSucceeded = createAction(
  GETTING_TEMPLATE_NAMES_BY_UUIDS_SUCCEEDED
);

export const gettingTemplateNamesByUuidsFailed = createAction(
  GETTING_TEMPLATE_NAMES_BY_UUIDS_FAILED
);

export const gettingTemplateFailed = createAction(GETTING_TEMPLATE_FAILED);

export const creatingTemplate = createAction(CREATING_TEMPLATE);

export const creatingTemplateSucceeded = createAction(
  CREATING_TEMPLATE_SUCCEEDED
);

export const creatingTemplateFailed = createAction(CREATING_TEMPLATE_FAILED);

export const updatingTemplate = createAction(UPDATING_TEMPLATE);

export const updatingTemplateSucceeded = createAction(
  UPDATING_TEMPLATE_SUCCEEDED
);

export const updatingTemplateFailed = createAction(UPDATING_TEMPLATE_FAILED);

export const deletingTemplates = createAction(DELETING_TEMPLATES);

export const deletingTemplatesSucceeded = createAction(
  DELETING_TEMPLATES_SUCCEEDED
);

export const deletingTemplatesFailed = createAction(DELETING_TEMPLATES_FAILED);

export const gettingAssociatedCampaignsForTemplate = createAction(
  GETTING_ASSOCIATED_CAMPAIGNS_FOR_TEMPLATE
);

export const gettingAssociatedCampaignsForTemplateSucceeded = createAction(
  GETTING_ASSOCIATED_CAMPAIGNS_FOR_TEMPLATE_SUCCEEDED
);

export const gettingAssociatedCampaignsForTemplateFailed = createAction(
  GETTING_ASSOCIATED_CAMPAIGNS_FOR_TEMPLATE_FAILED
);

export const setCopyCurrentTemplate = createAction(SET_COPY_CURRENT_TEMPLATE);

export const testTemplate = createAction(TEST_TEMPLATE);

export const getPaginatedTemplates = createAction(GET_PAGINATED_TEMPLATES);
export const getMinimalTemplates = createAction(GET_MINIMAL_TEMPLATES);
//No of rows is defined in user store
export const getTemplateTags = createAction(GET_TEMPLATE_TAGS);
export const gettingTemplateTags = createAction(GETTING_TEMPLATE_TAGS);
export const gettingTemplateTagsSucceeded = createAction(
  GETTING_TEMPLATE_TAGS_SUCCEEDED
);
export const gettingTemplateTagsFailed = createAction(
  GETTING_TEMPLATE_TAGS_FAILED
);

export const testingTemplate = createAction(TESTING_TEMPLATE);

export const testingTemplateSucceeded = createAction(
  TESTING_TEMPLATE_SUCCEEDED
);

export const testingTemplateFailed = createAction(TESTING_TEMPLATE_FAILED);

export const templateAutoSaveTimerStart = createAction(
  TEMPLATE_AUTO_SAVE_TIMER_START
);

export const templateAutoSaveTimerEnd = createAction(
  TEMPLATE_AUTO_SAVE_TIMER_END
);

export const updateCommunicationFilters = createAction(UPDATE_COMMUNICATION_FILTERS);
export const resetCommunicationFilters = createAction(RESET_COMMUNICATION_FILTERS);